import React from "react";
import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({
    open,
    title = "Emin misiniz?",
    subtitle = "Bu işlem geri alınamaz.",
    message,
    confirmLabel = "Sil",
    tone = "danger",
    onConfirm,
    onCancel,
    busy = false,
}) {
    if (!open) return null;
    const toneStyles =
        tone === "warning"
            ? {
                  iconWrap: "bg-amber-500/10 border-amber-500/30",
                  icon: "text-amber-400",
                  btn: "bg-amber-500 hover:bg-amber-600 text-black",
              }
            : {
                  iconWrap: "bg-rose-500/10 border-rose-500/30",
                  icon: "text-rose-400",
                  btn: "bg-rose-500 hover:bg-rose-600 text-white",
              };
    return (
        <div
            data-testid="confirm-dialog"
            className="fixed inset-0 z-[120] flex items-center justify-center"
        >
            <div
                className="absolute inset-0 bg-black/70 backdrop-blur-sm"
                onClick={onCancel}
            />
            <div className="relative w-full max-w-md mx-4 bg-[#121A2F] border border-white/10 rounded-lg shadow-2xl animate-fade-in">
                <div className="px-6 py-5 border-b border-white/10 flex items-center gap-3">
                    <div
                        className={`h-10 w-10 rounded-full border flex items-center justify-center ${toneStyles.iconWrap}`}
                    >
                        <AlertTriangle className={`h-5 w-5 ${toneStyles.icon}`} />
                    </div>
                    <div>
                        <div className="font-display text-lg text-white">
                            {title}
                        </div>
                        {subtitle ? (
                            <div className="text-xs text-slate-400">{subtitle}</div>
                        ) : null}
                    </div>
                </div>
                <div className="px-6 py-5 text-sm text-slate-300 whitespace-pre-line">
                    {message}
                </div>
                <div className="px-6 py-4 border-t border-white/10 flex items-center justify-end gap-3">
                    <button
                        data-testid="confirm-cancel"
                        onClick={onCancel}
                        className="h-9 px-4 rounded-md border border-white/10 text-slate-300 hover:bg-white/5 text-sm"
                    >
                        İptal
                    </button>
                    <button
                        data-testid="confirm-ok"
                        onClick={onConfirm}
                        disabled={busy}
                        className={`h-9 px-4 rounded-md text-sm inline-flex items-center gap-2 disabled:opacity-60 ${toneStyles.btn}`}
                    >
                        {busy && (
                            <div className="h-4 w-4 rounded-full border-2 border-white/50 border-t-transparent animate-spin" />
                        )}
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
